import React from "react";

import { Popover } from "antd";
import CommonUtil from "../../../utils/CommonUtil";
import { constants } from "../../../utils/Constants";
import SecurityUtils from "../../../utils/SecurityUtils";

class TableUtils {
  static textFormatter = (cell, row) => {
    let className = "column";
    if (constants.KNOWLEDGE_ENTITY_TYPE === row.type) {
      if (
        !SecurityUtils.userHasPermissionOnEntity(row, constants.OPERATION_READ)
      ) {
        className = "nonselectableTableRow";
      }
    }

    return row.active === false ? (
      <Popover content={cell} placement="topLeft">
        <div className="deletedTableRow">{cell}</div>
      </Popover>
    ) : (
      <Popover content={cell} placement="topLeft">
        <div className={className}>{cell}</div>
      </Popover>
    );
  };

  static dateFormatter = (cell, row) => {
    const formattedDate = CommonUtil.formatDateTime(cell);
    return this.textFormatter(formattedDate, row);
  };

  static textFilter = (
    placeholder,
    comparator,
    className = "table-filter",
    delay = 700 // react bootstrap table 2 default is 500ms
  ) => {
    return {
      type: "text",
      placeholder: placeholder,
      comparator: comparator,
      className: className,
      delay: delay
    };
  };
}
export default TableUtils;
